import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnInit, Output } from "@angular/core";
import { Cookie } from "ng2-cookies/ng2-cookies";
import { ConfigService } from "../../../../services/configService";
import { BaseResponse } from "../../../../objects/common/baseResponse";
import { SearchResponse } from "../../../../objects/responses/searchResponse";
import { User } from "../../../../objects/users/user";
import { AgentColorLink } from "../../../../objects/report/agentColorLink";
import { TotalFeeResponse } from "../../../../objects/report/totalFeeResponse";
import set = Reflect.set;
declare var $: any;
/**
 * Created by alex.y on 9/22/2017.
 */
@Component({
    selector: "agent-selector",
    templateUrl: "./agentSelector.component.html",
    moduleId: module.id.toString()
})
export class AgentSelectorComponent implements AfterViewInit {
    @Output()
    public agentsChange: EventEmitter<Array<number>> = new EventEmitter();

    @Input()
    public currentAgent: User = new User();

    @Input()
    public select2Id: string;

    @Input()
    public agentColors: Array<AgentColorLink> = [];

    @Input()
    public allAgents: Array<User> = [];

    public select: any;

    constructor(private configService: ConfigService) {
    }

    public ngAfterViewInit(): void {
        this.initAgentSelect();
    }

    public setValue(): void {
        let selector = $(`#${this.select2Id}`);

        if (selector)
            this.agentsChange.emit(selector.val());
    }

    private initAgentSelect(): void {
        var self = this;

        let init: boolean = true;
        let data: Array<any> = [];

        for (let item of this.allAgents) {
            data.push({
                id: item.Id,
                text: item.Email,
                Item: item
            })
        }

        let timerId: any;
        let isUnselect: boolean = false;

        this.select = $(`#${this.select2Id}`);

        this.select.select2({
            width: '100%',
            data: data,
            allowClear: true,
            placeholder: 'Select agents',
            multiple: 'multiple',
            closeOnSelect: true,
            templateSelection: function (state: any) {
                let colorObj = self.agentColors.find(x => x.Email == state.text);

                let color = "#EB5757";

                if (colorObj)
                    color = colorObj.color;

                return `<i class="material-icons circle-icon" style="color:${color}">fiber_manual_record</i><span style="color:${color}">${state.text}</span>`;
            },
            escapeMarkup: function (m: any) {
                return m;
            }
        }).on('select2:select', function (e: any) {
            let dataArray: number[] = $(this).val();

            if (!init)
                self.agentsChange.emit(dataArray);

            let t = $('[aria-selected = "false"]').length;

            if (t == 0)
                $(this).select2("close");
        }).on('select2:opening', function (e: any) {
            if (isUnselect) {
                e.preventDefault();
                isUnselect = false;
            }
        }).on('select2:unselect', function (e: any) {
            isUnselect = true;
            let dataArray: number[] = $(this).val();

            if(timerId)
                clearTimeout(timerId);

            timerId = setTimeout(() => {
                self.agentsChange.emit(dataArray);
            }, 1000);
        }).on('select2:open', function (params: any) {
            let select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });

        if (data.length == 1)
            this.select.val(Cookie.get(this.configService.config.UserCookieName)).trigger("change");
        else {
            let select2Data = $(`#${this.select2Id}`).data("select2");

            for (let dat of data)
                select2Data.trigger("select", { data: dat });
        }
        init = false;
    }

    public resizeSelect(height: number): void {
        if (height > 0)
            $(`.select2-selection--multiple`).css("max-height", height);
    }
}


// WEBPACK FOOTER //
// ./app/components/reports/filterSelectors/agentSelector/agentSelector.component.ts